import React from 'react';
import createSvgIcon from '@mui/material/utils/createSvgIcon.js';

export default createSvgIcon(
  <path d="M16.7654 16.4198v-2.8642h2.0741v4.2469L9.358 22 2 14.642l4.1975-9.4815h4.247v2.074H7.5801l-3.0617 6.963 5.284 5.284zM22 5.1605v2.074h-3.1605v3.1606h-2.074V7.2346h-3.1606V5.1605h3.1605V2h2.0741v3.1605z" />,
  'PolygonPlus',
);
